(function () {
  'use strict';

  var wiredMega = null;
  var wiredShopLink = null;
  var isOpen = false;
  var leaveTimer = null;
  var rewireTimer = null;

  function findMega() {
    return document.querySelector('.btp-mega-menu');
  }

  function findShopLink(triggerText) {
    var lower = triggerText.toLowerCase();
    var candidates = document.querySelectorAll(
      '.menu-list__link, #header-component a, #header-component button'
    );
    for (var i = 0; i < candidates.length; i++) {
      if (candidates[i].textContent.trim().replace(/\s+/g, ' ').toLowerCase() === lower) {
        return candidates[i];
      }
    }
    return null;
  }

  function doClose() {
    isOpen = false;
    if (wiredMega) wiredMega.classList.remove('is-open');
    if (wiredShopLink) {
      wiredShopLink.removeAttribute('aria-expanded');
      wiredShopLink.classList.remove('is-active');
    }
  }

  function doOpen() {
    clearTimeout(leaveTimer);
    isOpen = true;
    if (wiredMega) wiredMega.classList.add('is-open');
    if (wiredShopLink) {
      wiredShopLink.setAttribute('aria-expanded', 'true');
      wiredShopLink.classList.add('is-active');
    }
  }

  function wireUp() {
    var mega = findMega();
    if (!mega) return;

    var triggerText = mega.getAttribute('data-trigger') || 'Shop';
    var shopLink = findShopLink(triggerText);
    if (!shopLink) return;

    /* Already wired to this exact pair — nothing to do */
    if (mega === wiredMega && shopLink === wiredShopLink) return;

    wiredMega = mega;
    wiredShopLink = shopLink;
    isOpen = false;

    shopLink.addEventListener('click', function (e) {
      e.preventDefault();
      isOpen ? doClose() : doOpen();
    });

    shopLink.addEventListener('mouseenter', function () {
      clearTimeout(leaveTimer);
      doOpen();
    });
    shopLink.addEventListener('mouseleave', function () {
      leaveTimer = setTimeout(doClose, 180);
    });

    mega.addEventListener('mouseenter', function () { clearTimeout(leaveTimer); });
    mega.addEventListener('mouseleave', function () { leaveTimer = setTimeout(doClose, 180); });
  }

  /* Global close handlers live outside wireUp so they are registered once */
  document.addEventListener('click', function (e) {
    if (!isOpen || !wiredMega || !wiredShopLink) return;
    if (!wiredMega.isConnected || !wiredShopLink.isConnected) return;
    if (
      wiredMega.contains(e.target) ||
      e.target === wiredShopLink ||
      wiredShopLink.contains(e.target)
    ) return;
    doClose();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isOpen) doClose();
  });

  /* Re-wire after Horizon section hydration replaces the DOM */
  function scheduleRewire() {
    clearTimeout(rewireTimer);
    rewireTimer = setTimeout(function () {
      if (wiredMega && !wiredMega.isConnected) {
        wiredMega = null;
        wiredShopLink = null;
        isOpen = false;
      }
      wireUp();
    }, 50);
  }

  var observer = new MutationObserver(scheduleRewire);
  observer.observe(document.body, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wireUp);
  } else {
    wireUp();
  }
}());
